import homeFunctions from './serie-design/serie-home-functions';

document.addEventListener("DOMContentLoaded", () => {
    homeFunctions.init();
});